import React, { useMemo, useState } from 'react'
import { ImageUpload } from 'web/src/app/root/components/common/images-uploader/image-upload'
import { Box } from '@material-ui/core'
import { useStyles } from './styles'
import { useSelector } from 'react-redux'
import { ImagesUploadModal } from './images-upload-modal'

export const ImagesSection = ({
    imagesForUpload,
    setImagesForUpload,
    setDeletedPictureKeys,
    deletedPictureKeys,
    isEdit,
    kind,
    submitUploadImages,
    loading,
    permissions,
    getImagesByDeviceId
}) => {
    const { theme } = useSelector(state => state.main)
    const classes = useStyles(theme)
    const [isModalOpen, setIsModalOpen] = useState(false)

    const render = useMemo(() => {
        switch (kind) {
            case 'avatar':
                return (
                    <ImageUpload
                        imagesForUpload={imagesForUpload}
                        setImagesForUpload={setImagesForUpload}
                        kind={kind}
                        isModalOpen={isModalOpen}
                        setIsModalOpen={setIsModalOpen}
                        loading={loading}
                        permissions={permissions}
                    />
                )

            default:
                return (
                    <Box className={classes.container}>
                        {imagesForUpload?.map((item, index) => {
                            return (
                                <ImageUpload
                                    key={index}
                                    imagesForUpload={imagesForUpload}
                                    setImagesForUpload={setImagesForUpload}
                                    setDeletedPictureKeys={
                                        setDeletedPictureKeys
                                    }
                                    deletedPictureKeys={deletedPictureKeys}
                                    data={item}
                                    indexOfCommentCard={index}
                                    isEdit={isEdit}
                                    permissions={permissions}
                                />
                            )
                        })}

                        {imagesForUpload?.length < 5 && (
                            <ImageUpload
                                imagesForUpload={imagesForUpload}
                                setImagesForUpload={setImagesForUpload}
                                permissions={permissions}
                            />
                        )}
                    </Box>
                )
        }
    }, [imagesForUpload, deletedPictureKeys, isEdit, kind])

    return (
        <>
            <Box>
                <ImagesUploadModal
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    imagesForUpload={imagesForUpload}
                    setImagesForUpload={setImagesForUpload}
                    deletedPictureKeys={deletedPictureKeys}
                    setDeletedPictureKeys={setDeletedPictureKeys}
                    isEdit={true}
                    submitUploadImages={submitUploadImages}
                    getImagesByDeviceId={getImagesByDeviceId}
                />
            </Box>
            {render}
        </>
    )
}
